// extracted by mini-css-extract-plugin
module.exports = {"pre":"BlogCode_pre__3Vg6b"};